var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcKeyword(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M20 4.88889V7.55556C20 8.08889 19.6444 8.44444 19.1111 8.44444C18.5778 8.44444 18.2222 8.08889 18.2222 7.55556V5.77778H12.8889V18.2222H14.6667C15.2 18.2222 15.5556 18.5778 15.5556 19.1111C15.5556 19.6444 15.2 20 14.6667 20H9.33333C8.8 20 8.44444 19.6444 8.44444 19.1111C8.44444 18.5778 8.8 18.2222 9.33333 18.2222H11.1111V5.77778H5.77778V7.55556C5.77778 8.08889 5.42222 8.44444 4.88889 8.44444C4.35556 8.44444 4 8.08889 4 7.55556V4.88889C4 4.35556 4.35556 4 4.88889 4H19.1111C19.6444 4 20 4.35556 20 4.88889Z",
    fill: "#333333"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcKeyword);
export default __webpack_public_path__ + "static/media/ic_keyword.77e0b44b5f077f0273ef47a9186d0a28.svg";
export { ForwardRef as ReactComponent };